import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import ApiService from "services/ApiService";
import { repeatEffect, settingsConfig } from "utils/commonFunc";
import HlsPlayer from "services/HlsPlayer";

// const gridData = [
//   { vehicleNo: '소네트01', runCount: "임 2697", departure: '04.27 23:33', arrival: '04.27 23:33', status: '운행중', location: '호매실' },
//   { vehicleNo: '소네트02', runCount: "임 2733", departure: '04.27 23:33', arrival: '04.27 23:33', status: '운행중', location: '호매실' },
//   { vehicleNo: '소네트03', runCount: "임 3101", departure: '04.27 23:33', arrival: '04.27 23:33', status: '운행중', location: '호매실' },
//   { vehicleNo: '소네트04', runCount: "임3684", departure: '04.27 23:33', arrival: '04.27 23:33', status: '운행중', location: '호매실' },
//   { vehicleNo: 'SUM01', runCount: "71조 0111", departure: '04.27 23:33', arrival: '04.27 23:33', status: '운행중', location: '호매실' },
// ];
// 임시 설정 
// 소네트1 ,01 , 소네트2 ,02  소네트3 -> 03 , sum01 -> 4 , 소네트 04 - > 5 
const FutureTotalContext = createContext(null);
// export function SwItsGetOperationRouteProvider({ children }) {
//   const [currentData, setCurrentData] = useState();

//   useEffect(() => {
//     return repeatEffect(async () => {
//       const response = await ApiService.get("newdashboard/ftrtrf/GetSelfDriving");
//       if (response.status === 200) {
//         const data = response.data;

//         setCurrentData({
//           updateTime: data.updateTime,
//           data: data,
//         });
//       }
//     }, settingsConfig().contentUpdateDelaySec);
//   }, []);

//   return (
//     <FutureTotalContext.Provider value={currentData}>
//       {children}
//     </FutureTotalContext.Provider>
//   );
// }
export function SwItsGetOperationRouteProvider({ children }) {
  const [currentData, setCurrentData] = useState();
  const intervalRef = useRef(null);

  const fetchData = async () => {
    try {
      const response = await ApiService.get("newdashboard/ftrtrf/GetSelfDriving");
      if (response.status === 200) {
        const data = response.data;
        setCurrentData({
          updateTime: data.updateTime,
          data: data,
        });
      }
    } catch (error) {
      console.error('SelfDriving fetch error:', error);
    }
  };

  useEffect(() => {
    fetchData(); // 최초 1회 호출
    intervalRef.current = setInterval(fetchData, 2000); // 2초마다 호출

    return () => clearInterval(intervalRef.current); // 언마운트 시 정리
  }, []);

  return (
    <FutureTotalContext.Provider value={currentData}>
      {children}
    </FutureTotalContext.Provider>
  );
}

// 미래교통 그리드 영역

export function SwItsFutureRouteGridInfo() {
  const currentData = useContext(FutureTotalContext);
  console.log('currentData :::', currentData);
  const matchData = [
    { vehicleNum: '2697', carName: "임 2697" },
    { vehicleNum: '2733', carName: "임 2733" },
    { vehicleNum: '3101', carName: "임 3101" },
    { vehicleNum: '3684', carName: "임 3684" },
    { vehicleNum: '2545', carName: "임 2545" }, // sum_01
  ];

  if (!currentData || !currentData.data) return null;

  const formatTime = (timeStr) => {
    if (!timeStr) return '-';
    const date = new Date(timeStr);
    return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  };

  // const isStale = (updtTm) => {
  //   if (!updtTm) return true;
  //   const now = new Date();
  //   const lastUpdate = new Date(updtTm);
  //   const diffInSeconds = Math.abs((now - lastUpdate) / 1000);
  //   return diffInSeconds > 60; // 기준 60초 
  // };

  const gridData = currentData.data.filter(v => v.vehicleNum)
    .sort((a, b) => {
      if (a.vehicleNum === 2545) return 1;
      if (b.vehicleNum === 2545) return -1;
      return a.vehicleNum - b.vehicleNum;
    })
    .map(item => {
      const vehicleNumStr = String(item.vehicleNum);
      const match = matchData.find(m => m.vehicleNum === vehicleNumStr);
      const carName = match ? match.carName : `임 ${vehicleNumStr}`;

      // const isDataStale = isStale(item.updtTm); // 통신이상구분
      const isRunning = item.stat === 1;

      // 통신 이상일 경우 모든 데이터 "-"
      // if (isDataStale) {
      //   return {
      //     vehicleNo: carName,
      //     runCount: '-',
      //     departure: '-',
      //     arrival: '-',
      //     status: '-',
      //     location: '-',
      //   };
      // }
      const location = isRunning ? (item.ixrNm || '-') : '-';
      const departure = item.startTm ? formatTime(item.startTm) : '-';

      let arrival = '-';
      if (!isRunning) {
        if (item.endTm && item.startTm && new Date(item.endTm) > new Date(item.startTm)) {
          arrival = formatTime(item.endTm);
        } else if (item.endTm) {
          arrival = formatTime(item.endTm);
        }
      }
      return {
        vehicleNo: carName,
        runCount: item.raceNum ?? '-',
        departure,
        arrival,
        status: isRunning ? '운행중' : '운행종료',
        location,
      };
    });

  return (
    <div className="ftvGrid">
      <div className="gridTitLi flx a_center j_spc_btw">
        <p className="vhi">차량번호</p>
        <p className="dpt">출발시간</p>
        <p className="fnsh">도착시간</p>
        <p className="crt">현재상태</p>
        {/* <p className="crtro">현재위치</p> */}
      </div>
      <div className="gridBox cst_scroll flx flx_col">
        {gridData.map((item, idx) => (
          <div key={idx} className="gridLi flx a_center j_spc_btw">
            <p className="vhi">{item.vehicleNo}</p>
            <p className="dpt">{item.departure}</p>
            <p className="fnsh">{item.arrival}</p>
            <p className="crt">{item.status}</p>
            {/* <p className="crtro">{item.location}</p> */}
          </div>
        ))}
      </div>
    </div>
  );
}
// 배포
// export function SwItsFutureRouteCctvInfo({ cameraCount, startIndex = 1 }) {
//   const currentData = useContext(FutureTotalContext);
//   const [playingStates, setPlayingStates] = useState({});

//   const matchData = [
//     { vehicleNum: '2697', carName: "소네트 임2697", img: '/images/dashboard/car1.png' },
//     { vehicleNum: '2733', carName: "소네트 임2733", img: '/images/dashboard/car1.png' },
//     { vehicleNum: '3101', carName: "소네트 임3101", img: '/images/dashboard/car3.jpg' },
//     { vehicleNum: '3684', carName: "소네트 임3684", img: '/images/dashboard/car5.jpg' },
//     { vehicleNum: '2545', carName: "에스유엠 임2545", img: '/images/dashboard/car4.png' }, // sum_01
//   ];

//   if (!currentData || !currentData.data) return null;

//   const vehicleData = currentData.data
//     .filter(v => v.vehicleNum)
//     .sort((a, b) => {
//       if (a.vehicleNum === 2545) return 1;
//       if (b.vehicleNum === 2545) return -1;
//       return a.vehicleNum - b.vehicleNum;
//     })
//     .slice(startIndex - 1, startIndex - 1 + cameraCount);

//   const handlePlayClick = (vehicleNum) => {
//     setPlayingStates(prev => ({
//       ...prev,
//       [vehicleNum]: !prev[vehicleNum],
//     }));
//   };

//   return (
//     <>
//       {vehicleData.map((vehicle) => {
//         const { vehicleNum, hlsAddr } = vehicle;
//         const vehicleNumStr = String(vehicleNum);
//         const isPlaying = playingStates[vehicleNumStr];

//         const match = matchData.find(m => m.vehicleNum === vehicleNumStr);
//         const carName = match ? match.carName : `임 ${vehicleNumStr}`;
//         const captureImg = match ? match.img : '/images/dashboard/default.jpg';

//         return (
//           <div key={vehicleNum} className="cctvBox">
//             <div className="titWrap">
//               <h2 className="tit">{carName}</h2>
//             </div>
//             <div
//               className="cctvArea"
//               style={{ cursor: 'pointer' }}
//               onClick={() => handlePlayClick(vehicleNumStr)}
//             >
//               {isPlaying && hlsAddr ? (
//                 <HlsPlayer
//                   src={hlsAddr}
//                   autoPlay={true}
//                   controls={true}
//                   muted={true}
//                   width="100%"
//                   height="100%"
//                   style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                 />
//               ) : (
//                 <img
//                   src={captureImg}
//                   alt={carName}
//                   style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                 />
//               )}
//             </div>
//           </div>
//         );
//       })}
//     </>
//   );
// }

// 테스트 영상버젼 
export function SwItsFutureRouteCctvInfo({ cameraCount, startIndex = 1 }) {
  const currentData = useContext(FutureTotalContext);
  const [playingStates, setPlayingStates] = useState({});

  const matchData = [
    { vehicleNum: '2697', carName: "소네트 임2697", img: '/images/dashboard/car1.png', testVideo: '/video/test1.mp4' },
    { vehicleNum: '2733', carName: "소네트 임2733", img: '/images/dashboard/car1.png', testVideo: '/video/test2.mp4' },
    { vehicleNum: '3101', carName: "소네트 임3101", img: '/images/dashboard/car3.jpg', testVideo: '/video/test3.mp4' },
    { vehicleNum: '3684', carName: "소네트 임3684", img: '/images/dashboard/car5.jpg', testVideo: '/video/test4.mp4' },
    { vehicleNum: '2545', carName: "에스유엠 임2545", img: '/images/dashboard/car4.png', testVideo: '/video/test5.mp4' },
  ];

  if (!currentData || !currentData.data) return null;

  const vehicleData = currentData.data
    .filter(v => v.vehicleNum)
    .sort((a, b) => {
      if (a.vehicleNum === 2545) return 1;
      if (b.vehicleNum === 2545) return -1;
      return a.vehicleNum - b.vehicleNum;
    })
    .slice(startIndex - 1, startIndex - 1 + cameraCount);

  const handlePlayClick = (vehicleNum) => {
    setPlayingStates(prev => ({
      ...prev,
      [vehicleNum]: !prev[vehicleNum],
    }));
  };

  return (
    <>
      {vehicleData.map((vehicle) => {
        const { vehicleNum, hlsAddr } = vehicle;
        const vehicleNumStr = String(vehicleNum);
        // const isPlaying = playingStates[vehicleNumStr];
        const isPlaying = playingStates[vehicleNumStr] ?? true; 

        const match = matchData.find(m => m.vehicleNum === vehicleNumStr);
        const carName = match ? match.carName : `임 ${vehicleNumStr}`;
        const captureImg = match ? match.img : '/images/dashboard/default.jpg';
        const testVideoSrc = match ? match.testVideo : '/videos/default.mp4';

        return (
          <div key={vehicleNum} className="cctvBox">
            <div className="titWrap">
              <h2 className="tit">{carName}</h2>
            </div>
            <div
              className="cctvArea"
              style={{ cursor: 'pointer' }}
              onClick={() => handlePlayClick(vehicleNumStr)}
            >
              {isPlaying ? (
                <video
                  src={testVideoSrc}
                  autoPlay
                  controls
                  muted
                  loop
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <img
                  src={captureImg}
                  alt={carName}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}